import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';

@Component({
    selector: 'app-button-drop-down',
    templateUrl: './button-drop-down.component.html',
    styleUrls: ['./button-drop-down.component.css'],

})
export class ButtonDropDownComponent implements OnInit {

    selectedTaskTypeLabel = '';


    @Input() taskType: string;
    @Input() buttons: any[];
    @Input() mode: string;

    @Output() outputToParent = new EventEmitter<any>();


    constructor(public taskService: TaskService) {
    }

    setType(value) {
        this.outputToParent.emit(value);
        jQuery('.box').removeClass('task');
        jQuery('.box').removeClass('meeting');
        jQuery('.box').removeClass('reminder');
        jQuery('.box').removeClass('note');
        jQuery('.box').addClass(value);
    }

    ngOnInit(): void {
        let label = this.buttons.filter(item => item['type'].toLowerCase() === this.taskType.toLowerCase());
        if (label.length !== 0) {
            this.selectedTaskTypeLabel = label[0]['type'];
            jQuery('.box').addClass(this.selectedTaskTypeLabel);
        }

    }


}
